export class LeaveModel {
    constructor(
        public Id?: number,
        public Tipo?: string,
        public FBaja?: string,
        public FAlta?: string,
        public Dias?: number,
        public Nj?: string) {
    }
}
